// Source: app/scripts/controllers/company-signature.js
/**
 * Created by ristes on 20.4.15.
 */


Auction.controller('CompanySignatureController', [
  '$scope',
  '$modal',
  '$filter',
  '$location',
  'toaster',
  'crudService',
  'Downloader',
  function ($scope, $modal, $filter, $location, toaster, crudService, Downloader) {

    $scope.afterInit = function (crudScope) {

      crudScope.downloadCompanySignatureAttachment = function (companySignatureId) {
        if(companySignatureId) {
          Downloader.download('/data/rest/portal_attachments/get_company_signature/' + companySignatureId);
        }
      };

    }

  }
]);
